import festivalApi from '../apis/festival'
import isBefore from 'date-fns/is_before'
import isAfter from 'date-fns/is_after'
import { FESTIVAL_SOCIAL_WORK_DAY_2026 } from '@/tools/AppConfig'

const state = {
  festivalDetail: {
    id: '',
    name: '',
    image: '',
    descript: '',
    participants: 0,
    views: 0,
    votes: 0
  },
  festivalRecords: {
    data: [],
    total: 0,
    currentPage: 0,
    lastPage: 1,
    loading: false
  },
  search: {
    keyword: '',
    sort: '',
    userId: '',
    toUserId: '',
    randomSeed: new Date().getTime()
  },
  earthdayInfo: {
  },
  earthdayFestivalDetail: {
    id: '',
    name: '',
    image: '',
    descript: '',
    participants: 0,
    views: 0,
    votes: 0
  }
}

const actions = {
  getFestivalDetail ({ commit }, { id }) {
    return festivalApi.getFestivalDetail(id)
      .then(data => {
        commit('setFestivalDetail', data.data)
        return data.data
      })
  },
  getEarthdayFestivalDetail ({ commit }, { id }) {
    return festivalApi.getFestivalDetail(id)
      .then(data => {
        commit('setEarthdayFestivalDetail', data.data)
        return data.data
      })
  },
  getFestivalRecords ({ commit }, options) {
    commit('setFestivalRecordsLoading', true)
    return festivalApi.getFestivalRecordList(options)
      .then((data) => {
        commit('setFestivalRecords', data)
        return data
      })
  },
  voteUpFestivalRecord ({ commit }, { recordId, user }) {
    return festivalApi.voteUp(recordId)
      .then(data => {
        commit('voteUpFestivalRecord', { data, recordId, user })
      })
  },
  addFestivalView ({ commit }, { id }) {
    return festivalApi.viewFestival(id)
  },
  addFestivalRecord ({ commit }, { data, user }) {
    return festivalApi.addFestivalRecord(data)
      .then((data) => {
        if (user) {
          data.user = user
        }
        commit('addFestivalRecord', data)
        return data
      })
  },
  addEarthdayFestivalRecord ({ commit }, { data, user }) {
    return festivalApi.addFestivalRecord(data)
      .then((data) => {
        if (user) {
          data.user = user
        }
        commit('addEarthdayFestivalRecord', data)
      })
  },
  getFestivalEarthDayInfo ({ commit }, { festivalId }) {
    return festivalApi.getFestivalEarthDayInfo(festivalId)
      .then((data) => {
        commit('setFestivalEarthDayInfo', data)
        return data
      })
  }
}

const mutations = {
  setFestivalDetail (state, data) {
    state.festivalDetail = data
  },
  setEarthdayFestivalDetail (state, data) {
    state.earthdayFestivalDetail = data
  },
  setFestivalRecordsLoading (state, loading) {
    state.festivalRecords = {
      ...state.festivalRecords,
      loading
    }
  },
  setFestivalRecords (state, data) {
    state.festivalRecords = {
      ...state.festivalRecords,
      currentPage: data.current_page,
      lastPage: data.last_page,
      data: data.current_page === 1 ? data.data : [...state.festivalRecords.data, ...data.data],
      total: data.total,
      loading: false
    }
  },
  addFestivalRecord (state, data) {
    state.festivalRecords = {
      ...state.festivalRecords,
      data: [data, ...state.festivalRecords.data],
      total: state.festivalRecords.total + 1
    }

    state.festivalDetail = {
      ...state.festivalDetail,
      participants: state.festivalDetail.participants + 1,
      myRecord: data
    }
  },
  addEarthdayFestivalRecord (state, data) {
    state.earthdayFestivalDetail = {
      ...state.earthdayFestivalDetail,
      participants: state.earthdayFestivalDetail.participants + 1,
      myRecord: data
    }
  },
  voteUpFestivalRecord (state, { data, recordId, user }) {
    for (let record of state.festivalRecords.data) {
      if (record.id === recordId) {
        record.last_votes = [
          user,
          ...record.last_votes
        ]
        record.vote_up += 1
        record.is_voted = 1
        break
      }
    }
    state.festivalDetail.votes += 1
  },
  setFestivalSearch (state, search) {
    state.search = {
      ...state.search,
      ...search
    }
  },
  setFestivalEarthDayInfo (state, data) {
    state.earthdayInfo = data
  },
  // 排序，將自己排在最前面
  sortFestivalRecords (state, myRecord) {
    state.festivalRecords = {
      ...state.festivalRecords,
      data: [myRecord, ...state.festivalRecords.filter(item => item.user_id === myRecord.user_id)]
    }
  },
  logout (state) {
    state.festivalDetail = {
      ...state.earthdayFestivalDetail,
      myRecord: null
    }
    state.festivalRecords = {
      data: [],
      total: 0,
      currentPage: 0,
      lastPage: 1,
      loading: false
    }
    state.search = {
      ...state.search,
      userId: '',
      toUserId: ''
    }
    state.earthdayInfo = {
    }
    state.earthdayFestivalDetail = {
      ...state.earthdayFestivalDetail,
      myRecord: null
    }
  }
}

export const getters = {
  isShowSocialWorkDay (state) {
    if (!state.festivalDetail.id || state.festivalDetail.id !== FESTIVAL_SOCIAL_WORK_DAY_2026) {
      return false
    }

    const now = new Date()

    if (isBefore(now, state.festivalDetail.endAt) && isAfter(now, state.festivalDetail.startAt)) {
      return true
    }

    return false
  },
  isShowEarthDay (state) {
    if (!state.earthdayFestivalDetail.id) {
      return false
    }

    const now = new Date()

    if (isBefore(now, state.earthdayFestivalDetail.endAt) && isAfter(now, state.earthdayFestivalDetail.startAt)) {
      return true
    }

    return false
  }
}

export default {
  state,
  mutations,
  actions,
  getters
}
